import { jsx as o } from "react/jsx-runtime";
import { Icon as t } from "./Icon.js";
const i = (r) => /* @__PURE__ */ o(t, { ...r, children: /* @__PURE__ */ o(
  "path",
  {
    d: "M10 7.2L10 10M10 12.8L9.993 12.8M3 10C3 6.13401 6.13401 3 10 3C13.866 3 17 6.13401 17 10C17 13.866 13.866 17 10 17C6.13401 17 3 13.866 3 10Z",
    stroke: "#CE1D1D",
    strokeWidth: "1.5",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }
) });
export {
  i as Exclamation
};
